import React from 'react';
import useImageSizes from '@loomstateorg/shared-frontend/hooks/useImageSizes';
import Tile, { TileProps } from '../tile';

export interface Props {
  tiles: TileProps[];
  backgroundClassName?: string;
  children?: React.ReactNode;
}

const TilesGroup: React.FC<Props> = ({ tiles, backgroundClassName = '' }) => {
  const imageSizes = useImageSizes({ md: 1, lg: 0.5, defaultSize: 0.5 });

  return (
    <div className={`${backgroundClassName} lg:px-20 xl:px-48`} data-testid="tiles-group">
      <div className={`flex flex-col ${backgroundClassName} md:flex-row lg:gap-16`}>
        {tiles.map((tile, index) => (
          <Tile
            key={index}
            {...tile}
            image={{ ...tile.image, layout: 'fill', sizes: imageSizes, alt: tile.image?.alt || 'Tile image' }}
            className="h-320 lg:h-[475px]"
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default TilesGroup;
